import store from '@/store'
import { SoundPlayer } from '@/utils/navigator/SoundPlayer'
import invisibleVueInstanceMixin from '@/mixins/invisibleVueInstanceMixin'
import { ALARM_SOUND, PTI_STATUS_INACTIVE } from '@/consts/pti'
import { createNamespacedHelpers } from 'vuex'

const { cordova } = window

const storeService = createNamespacedHelpers('service')
export default {
  store,
  eventSettingsCheckKey: null,
  statusList: [],
  mixins: [invisibleVueInstanceMixin],
  data () {
    return {
      status: PTI_STATUS_INACTIVE.value,
      statusLog: []
    }
  },
  created () {
    if (cordova) {
      document.addEventListener(
        'deviceready', () => {
          this.alarmPlayer = new SoundPlayer(ALARM_SOUND)
        }, false)
    } else {
      this.alarmPlayer = new SoundPlayer(ALARM_SOUND)
    }
  },
  computed: {
    ...storeService.mapGetters({
      serviceActif: 'serviceActif',
      isPaused: 'isPaused'
    }),
    isAgencyCheckActive () {
      const { eventSettingsCheckKey } = this.$options
      return eventSettingsCheckKey
        ? _.get(store.getters['user/company'], ['agencySettingsFeature', eventSettingsCheckKey], true)
        : true
    },
    isActive () {
      return (this.isAgencyCheckActive && this.serviceActif && !this.isPaused) || false
    },
    indexedStatusList () {
      return _.keyBy(this.$options.statusList, 'value')
    },
    statusLabel () {
      const statusInfos = this.indexedStatusList[this.status]
      return statusInfos
        ? statusInfos.label
        : 'Indéterminé'
    }
  },
  watch: {
    isActive: {
      immediate: true,
      handler: '_onActiveStateChange'
    },
    status () {
      this.statusLog.push({
        date: new Date().getTime(),
        status: this.statusLabel
      })
    }
  },
  methods: {
    _onActiveStateChange () {
      console.warn(`Overwride _onActiveStateChange on ${this.$options.name} to handle state change`)
    },
    alarmPlay (opt) {
      return this.alarmPlayer && this.alarmPlayer.play(opt)
    },
    alarmStop () {
      return this.alarmPlayer && this.alarmPlayer.stop()
    }
  }
}
